<router-outlet />

@if (isInitialNavigationPending) {
  <div
    class="fixed inset-0 z-[9999] flex min-h-screen items-center justify-center bg-slate-50"
    role="status"
    aria-live="polite"
    aria-label="Anwendung wird geladen"
  >
    <div class="flex flex-col items-center gap-4 text-slate-600">
      <app-loading-spinner aria-hidden="true"></app-loading-spinner>
      <span class="text-sm font-medium">Anwendung wird geladen…</span>
    </div>
  </div>
}
